/**
 * /app/$tenantSlug/posh — old POSH overview. Nothing links here any more:
 * POSH lives at Me → POSH → Training for everyone and at Manage → POSH
 * (/posh/compliance) for HR. This URL sends each person to their home
 * (bookmarks and old links keep working).
 */

import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth";
import { isHRAdmin } from "@/lib/nav";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/posh/")({
  component: PoshHomeRedirect,
});

function PoshHomeRedirect() {
  const { tenantSlug } = Route.useParams();
  const { user } = useAuth();
  return (
    <Navigate
      to={isHRAdmin(user?.role) ? "/app/$tenantSlug/posh/compliance" : "/app/$tenantSlug/posh/training"}
      params={{ tenantSlug }}
      replace
    />
  );
}
